<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="row g-1">

            <div class="col-12">
                <div class="alert alert-danger" v-if="Object.keys(errors).length > 0">
                    <div class="mb-2">
                        <strong>
                            Ops! Algo deu errado.
                        </strong>
                    </div>

                    <ul v-for="(error, key) in errors" :key="key" class="m-0 py-0 px-3">
                        <li v-for="message in error" :key="message">
                            {{ message }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Tipo de Documento -->
            <div class="col-md-3">
                <b-form-group label="Tipo de Documento">
                    <b-select
                        v-model="form.document_type"
                        @change="changeTypeDocumentSelect">
                        <b-select-option value="CPF">Pessoa Física</b-select-option>
                        <b-select-option value="CNPJ">Pessoa Jurídica</b-select-option>
                    </b-select>
                </b-form-group>
            </div>

            <!-- CPF / CPNJ -->
            <div class="col-md-4">
                <b-form-group label="CPF" v-if="form.document_type === 'CPF'">
                    <input
                        type="tel"
                        v-mask="'###.###.###-##'"
                        placeholder="ex: 000.000.000-00"
                        :value="form.document"
                        class="form-control"
                        @input="changeCpfInput"
                    />
                </b-form-group>

                <b-form-group label="CNPJ" v-else>
                    <input
                        type="tel"
                        v-mask="'##.###.###/####-##'"
                        placeholder="ex: 00.000.000/0000-00"
                        :value="form.document"
                        class="form-control"
                        @input="changeCnpjInput"
                    />
                </b-form-group>
            </div>

            <!-- Email -->
            <div class="col-md-5">
                <b-form-group label="Email">
                    <b-form-input
                        type="email"
                        v-model="form.email"
                        placeholder="ex: meuemail@minhaempresa.com"
                    />
                </b-form-group>
            </div>

            <!-- Phone -->
            <div class="col-md-4">
                <b-form-group label="Telefone">
                    <input
                        type="tel"
                        v-mask="['(##) #####-####', '(##) ####-####']"
                        placeholder="ex: (00) 00000-0000"
                        :value="form.phone"
                        @input="changePhoneInput"
                        class="form-control"
                    />
                </b-form-group>
            </div>

            <!-- Nome / Razão Social -->
            <div class="col-md-8">
                <b-form-group :label="form.document_type === 'CPF' ? 'Nome Completo' : 'Razão Social'">
                    <b-form-input
                        v-model="form.social_name"
                        :placeholder="form.document_type === 'CPF' ? 'ex: João da Silva' : 'ex: Minha Empresa'"
                    />
                </b-form-group>
            </div>

            <!-- CEP -->
            <div class="col-md-3">
                <b-form-group label="CEP">
                    <input
                        type="tel"
                        v-mask="'#####-###'"
                        placeholder="00000-000"
                        :value="form.zip_code"
                        @input="changeZipCodeInput"
                        class="form-control"
                    />
                </b-form-group>
            </div>

            <!-- Estado -->
            <div class="col-md-4">
                <b-form-group label="Estado">
                    <b-form-select
                        v-model="form.state"
                        :options="statesOfBrazil"
                    />
                </b-form-group>
            </div>

            <!-- Cidade -->
            <div class="col-md-5">
                <b-form-group label="Cidade">
                    <b-form-input
                        v-model="form.city"
                        placeholder="ex: São Paulo"
                    />
                </b-form-group>
            </div>

            <!-- Bairro -->
            <div class="col-md-3">
                <b-form-group label="Bairro">
                    <b-form-input
                        v-model="form.neighborhood"
                        placeholder="ex: Bela Vista"
                    />
                </b-form-group>
            </div>

            <!-- Endereço -->
            <div class="col-md-6">
                <b-form-group label="Endereço">
                    <b-form-input
                        v-model="form.street"
                        placeholder="ex: Av. Paulista"
                    />
                </b-form-group>
            </div>

            <!-- Número -->
            <div class="col-md-3">
                <b-form-group label="Número">
                    <b-form-input
                        v-model="form.number"
                        placeholder="ex: 123"
                    />
                </b-form-group>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import cep from "../customer/mixins/cep";
import cnpj from "../customer/mixins/cnpj";
import cpf from "../customer/mixins/cpf";
import phone from "../customer/mixins/phone";
import document from "../customer/mixins/document";

export default {
    mixins: [cep, cnpj, cpf, phone, document],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                document_type: 'CPF',
                document: null,
                social_name: null,
                phone: null,
                email: null,
                zip_code: null,
                state: null,
                city: null,
                neighborhood: null,
                street: null,
                number: null,
            }
        }
    },
    watch: {
        form: {
            handler: function (value) {
                this.$emit('update', this.mountFormRequest(value));
            },
            deep: true
        }
    },
    async created() {
        await this.loadBillingInformation();
    },
    methods: {
        async loadBillingInformation() {
            this.loading = true;

            await axios.get('/teacher/pagarme/customer/information')
                .then((response) => {
                    let result = response.data.data.customer;

                    this.canSearchCep = false;
                    this.canSearchCpf = false;
                    this.canSearchCnpj = false;

                    this.form.document_type = result.document_type;
                    this.form.document = result.document;
                    this.form.social_name = result.social_name;
                    this.form.phone = result.phone;
                    this.form.email = result.email;

                    this.form.zip_code = result.zip_code;
                    this.form.state = result.state;
                    this.form.city = result.city;
                    this.form.neighborhood = result.neighborhood;
                    this.form.street = result.street;
                    this.form.number = result.number;
                })
                .finally(() => {
                    this.canSearchCep = true;
                    this.canSearchCpf = true;
                    this.canSearchCnpj = true;
                    this.loading = false;
                })
        },

        mountFormRequest(form) {
            return {
                name: form.social_name,
                email: form.email,
                document: form.document,
                document_type: form.document_type,
                type: form.document_type === 'CPF' ? 'individual' : 'company',
                phones: {
                    mobile_phone: {
                        country_code: '55',
                        area_code: this.getOnlyDDDOfPhone(form.phone),
                        number: this.getOnlyNumberPhone(form.phone),
                    }
                },
                address: {
                    line_1: this.createLineAddress(form.number, form.street, form.neighborhood),
                    line_2: '',
                    zip_code: form.zip_code,
                    city: form.city,
                    state: form.state,
                    country: 'BR',
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
